import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { resolveHub } from "@/lib/geo-origin-resolver";
import { AIRPORTS } from "@/lib/airports";

// Gdy hub (np. WAW) należy do grupy metro (np. WAR = Warszawa wszystkie),
// preferuj kod metro — user dostaje "Warszawa (wszystkie)" jako pierwszą
// podpowiedź, a nie konkretne lotnisko Chopina.
const HUB_TO_METRO: Record<string, string> = (() => {
  const out: Record<string, string> = {};
  for (const a of AIRPORTS) {
    if (a.isMetro && a.members) {
      for (const m of a.members) out[m] = a.code;
    }
  }
  return out;
})();

/**
 * Server-only: czyta nagłówki Cloudflare (kraj/miasto/lat/lon) i zwraca
 * sugerowany hub wylotu jako kod IATA. Używane przez SSR loadery `/`,
 * `/tanie-loty` i innych landingów, żeby SearchForm dostał `initial.from`
 * zgodne z lokalizacją usera — bez migotania po hydratacji. Fallback: "WAR".
 *
 * Nie zapisujemy już diagnostycznego eventu SSR do bazy: przy ruchu SEO/botów
 * każdy render tworzył dodatkowy INSERT w `analytics_events`, co podbijało
 * zużycie Lovable Cloud bez wpływu na UX.
 */
export const getInitialOrigin = createServerFn({ method: "GET" })
  .inputValidator((d: unknown) => {
    const x = (d ?? {}) as { page?: unknown };
    const page = typeof x.page === "string" ? x.page.slice(0, 100) : null;
    return { page };
  })
  .handler(async () => {
    try {
      const country = (getRequestHeader("cf-ipcountry") || "").toUpperCase() || null;
      const city = getRequestHeader("cf-ipcity") || null;
      const latRaw = getRequestHeader("cf-iplatitude");
      const lonRaw = getRequestHeader("cf-iplongitude");
      const lat = latRaw ? Number(latRaw) : null;
      const lon = lonRaw ? Number(lonRaw) : null;
      const resolved = resolveHub({ country, city, lat, lon });

      const from = HUB_TO_METRO[resolved.hub] ?? resolved.hub;
      return { from, reason: resolved.reason };
    } catch {
      return { from: "WAR", reason: "default" as const };
    }
  });
